module.exports=function(e){var t={};function o(r){if(t[r])return t[r].exports;var n=t[r]={i:r,l:!1,exports:{}};return e[r].call(n.exports,n,n.exports,o),n.l=!0,n.exports}return o.m=e,o.c=t,o.d=function(e,t,r){o.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},o.t=function(e,t){if(1&t&&(e=o(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(o.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var n in e)o.d(r,n,function(t){return e[t]}.bind(null,n));return r},o.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return o.d(t,"a",t),t},o.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},o.p="",o(o.s=87)}({1:function(e,t){e.exports=require("react")},10:function(e,t){e.exports=require("../../styles/breakpoints")},2:function(e,t){e.exports=require("styled-components")},3:function(e,t){e.exports=require("../../styles")},5:function(e,t){e.exports=require("../Icon/Icon")},87:function(e,t,o){"use strict";var r=this&&this.__createBinding||(Object.create?function(e,t,o,r){void 0===r&&(r=o),Object.defineProperty(e,r,{enumerable:!0,get:function(){return t[o]}})}:function(e,t,o,r){void 0===r&&(r=o),e[r]=t[o]}),n=this&&this.__setModuleDefault||(Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t})}:function(e,t){e.default=t}),i=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)"default"!==o&&Object.hasOwnProperty.call(e,o)&&r(t,e,o);return n(t,e),t},l=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const a=i(o(1)),d=l(o(2)),u=l(o(5)),c=l(o(10)),s=o(3),{MiscPalette:f,KineduPalette:p}=s.colorPalettes,b=d.default.div`
  border-radius: 5px;
  bottom: 5px;
  left: 50%;
  min-width: 95%;
  padding: 5px;
  position: fixed;
  transform: translateX(-50%);

  ${c.default.desktop} {
    background-color: ${f.white};
    bottom: initial;
    display: none;
    font-size: 12px;
    font-weight: 325;
    left: initial;
    line-height: 16px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    ::before,
    ::after {
      border-bottom: 8px solid transparent;
      border-right-style: solid;
      border-right-width: 14px;
      border-top: 8px solid transparent;
      content: "";
      display: block;
      height: 0;
      left: -14px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
    }

    ::after {
      border-right-color: white;
      left: -12px;
    }
  }
`,h=d.default.div`
  border-radius: 50%;
  border: 1px solid ${({color:e})=>e||p.shadeMediumLight};
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: ${({width:e})=>e||"24px"};
  margin: 5px;
  position: relative;
  width: ${({width:e})=>e||"24px"};
  background-color: ${({bgColor:e})=>e||p.shadeMediumLight};

  .Tooltip-icon * {
    stroke: none;
  }

  ${b} {
    border: 1px solid ${({color:e})=>e||p.shadeMediumLight};
    color: ${({colorText:e})=>e||p.shadeDark};
    right: ${({widthContent:e})=>`calc((${e} + 25px) * -1)`||"-229px"};
    width: ${({widthContent:e})=>e||"204px"};

    ::before {
      border-right-color: ${({color:e})=>e||p.shadeMediumLight};
    }
  }

  ${b} {
    display: ${({active:e})=>e?"block":"none"};
  }

  ${c.default.desktop} {
    ${b} {
      display: none;
    }
    &:hover ${b} {
      display: block !important;
    }
  }

  ${({disabled:e})=>e&&"pointer-events: none; opacity: .5"}
`;t.default=({classNames:e,color:t,colorText:o,disabled:r,icon:n,iconColor:i,onClick:l,text:d,width:c,widthContent:s,bgColor:f})=>{const[m,x]=a.useState(!1),g=()=>{m&&x&&x(!1)};return a.useEffect(()=>(document.addEventListener("click",g),()=>{document.removeEventListener("click",g)})),a.default.createElement(h,{className:e||"Tooltip",color:t,bgColor:f,colorText:o,disabled:r,onClick:()=>(x(!m),l&&l(),m),width:c,widthContent:s,active:m},a.default.createElement(u.default,{name:n||"exclamation",size:20,className:"Tooltip-icon",color:i||p.shadeDark}),d?a.default.createElement(b,null,d):null)}}});